import classNames from "classnames";
import { Component } from "react";

import { UserAvatarsQueryFragmentFragmentDoc } from "../../generated/schema";
import { firstFragmentName } from "../../utils/firstFragmentName";
import type { ConnectionWithTotalCount, RelayId } from "../../utils/relay";

import type { SizeType } from "./UserAvatar";
import { UserAvatar } from "./UserAvatar";
import { UserAvatarWithPopup } from "./UserAvatarWithPopup";

export const UserAvatarsQueryFragment = UserAvatarsQueryFragmentFragmentDoc;
export const UserAvatarsQueryFragmentName = firstFragmentName(UserAvatarsQueryFragment);

export interface UserType {
  id: RelayId;
  account: string;
  avatar1x: {
    url: string;
  };
  avatar2x: {
    url: string;
  };
}

interface Props {
  users: ConnectionWithTotalCount<UserType>;
  size: SizeType;
  isPopup?: boolean;
  isLink?: boolean;
  isOverlapped?: boolean;
  limit?: number;
}

export class UserAvatars extends Component<Props> {
  static readonly defaultProps = {
    isPopup: true,
    isLink: true,
    isOverlapped: true,
  };

  render() {
    const { isOverlapped, limit } = this.props;
    const users = this.props.users.edges.map((edge) => edge.node).slice(0, limit);

    return (
      <div className={classNames("userAvatars", isOverlapped && "is-overlapped")}>
        {users.map((user) => {
          if (this.props.isPopup) {
            return (
              <UserAvatarWithPopup key={user.account} user={user} size={this.props.size} isLink={this.props.isLink} />
            );
          } else {
            return <UserAvatar key={user.account} user={user} size={this.props.size} isLink={this.props.isLink} />;
          }
        })}
      </div>
    );
  }
}
